import styles from './style.postcss';
import classnames from 'classnames';

import React from 'react';
import PropTypes from 'prop-types';

const NormalTd = (props) => <td {...props} className={classnames(styles.NormalTd, props.className)}>
  {props.children}
</td>;

NormalTd.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default NormalTd;



// WEBPACK FOOTER //
// ./components/TableView/Tds/NormalTd/index.jsx